import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';
import { Swiper } from 'swiper/react';

export const CarouselSlideWrapper = styled.div`
  align-items: center;
  display: flex;
`;

export const CarouselPaginationBullets = styled.div`
  display: flex;
  align-items: center;

  &.swiper-pagination-horizontal {
    align-self: center;
    bottom: 0;
    position: relative;
    width: fit-content;

    > span {
      vertical-align: middle;
    }
  }

  .swiper-pagination-bullet {
    background: ${baseVariables.color.base10};
    height: ${toRem(6)};
    opacity: 0.7;
    transform: scale(1);
    transition: transform 750ms;
    width: ${toRem(6)};

    &.swiper-pagination-bullet-active {
      opacity: 1;
      transform: scale(1.7);
      transition: transform 750ms;
    }
  }
`;

export const CarouselSwiper = styled(Swiper)`
  display: flex !important; // override out-of-the-box swiper styles
  flex-direction: column;
  position: relative;
  width: 100%;
`;
